<template>
	<div class="footer">
		<div class="wx-qrcode">
			<img src="http://cfes.oss-cn-beijing.aliyuncs.com/img/QRcode.png" alt="" />
			<p>扫码添加微信交流</p>
		</div>
		<div class="foot-describe">
			<p>感谢您对橙风而上品牌设计的兴趣，</p>
			<p>请与我们建立联系。</p>
			<p>共同塑造极具国际化的品牌形象。</p>
		</div>
		<div class="foot-info">
			<p>地址：上海市黄浦区徐家汇路560号</p>
			<p>电话：021-5452 5560</p>
			<p>手机：159-0040-5050</p>
			<p>邮箱：1661882218@qq.com</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "footerNav",
		components: {},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		computed: {},
		watch: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.footer {
		background-color: #000;
		color: #DDD;
		padding: 40px;
    margin-bottom: 30px;
		.wx-qrcode {
			text-align: center;
			font-size: 14px;

			img {
				width: 105px;
				margin-bottom: 12px;
			}
		}

		.foot-describe {
			font-size: 15px;
			line-height: 24px;
			margin-bottom: 12px;
			padding-bottom: 10px;
			border-bottom: 1px solid #FF6600;
			margin-top: 80px;
		}

		.foot-info {
			font-size: 12px;

			p {
				padding: 5px 0;
			}
		}
	}
</style>